import { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { DATE_FORMATS } from '@callmart/types';
import SelectExportDateRangeDialog from '../Dialogs/SelectExportDateRangeDialog';
import UserContext from '../../store/User/UserContext';
import dayjs from '@utils/dayjs';

const StrategicVolumeExportDialog = ({
    open,
    onClose,
    startDate,
    onStartDateChange,
    endDate,
    onEndDateChange,
    createExcelRowForExport,
    getDataFromDb,
    getExportData,
    exportColumnNames,
}) => {
    const { t } = useTranslation('bidding');
    const loggedInUser = useContext(UserContext);

    // WFM (via isTEFUser) and WTM both get the 12-month manager export range.
    const numOfNextMonths = loggedInUser?.isTEFUser || loggedInUser?.isWTMUser ? 12 : 6;
    const startDateOptions = Array.from({ length: 13 }, (_, i) => ({
        month: dayjs().subtract(i, 'months').format(DATE_FORMATS.ISO_DATE),
        monthName: dayjs().subtract(i, 'months').format(DATE_FORMATS.MONTH_NAME_YEAR),
    }));

    const endDateOptions = Array.from({ length: numOfNextMonths }, (_, i) => ({
        month: dayjs()
            .add(i + 1, 'months')
            .format(DATE_FORMATS.ISO_DATE),
        monthName: dayjs()
            .add(i + 1, 'months')
            .format(DATE_FORMATS.MONTH_NAME_YEAR),
    }));

    useEffect(() => {
        if (!startDate && startDateOptions.length > 0) {
            onStartDateChange(startDateOptions[0].month);
        }
        if (!endDate && endDateOptions.length > 0) {
            onEndDateChange(endDateOptions[1].month);
        }
    }, [startDate, endDate, startDateOptions, endDateOptions, onStartDateChange, onEndDateChange]);

    return (
        <SelectExportDateRangeDialog
            open={open}
            onClose={onClose}
            selectedStartDate={startDate}
            onStartDateChange={onStartDateChange}
            selectedEndDate={endDate}
            onEndDateChange={onEndDateChange}
            startDateOptions={startDateOptions}
            endDateOptions={endDateOptions}
            getExportData={getExportData}
            getDataFromDb={getDataFromDb}
            createRowFromExportData={createExcelRowForExport}
            exportedDataType={t('export.fileName')}
            dialogTitle={t('export.dialogTitle')}
            exportColumnNames={exportColumnNames}
            dialogText={t('export.dialogText')}
        ></SelectExportDateRangeDialog>
    );
};

export default StrategicVolumeExportDialog;
